import { DialogContent } from "@mui/material";
import PasswordInput from "common/components/PasswordInput/PasswordInput";
import React, { useState } from "react";

export const DialogUpdatePasswordContent = ({
    originalPassword,
    setOriginalPassword,
    newPassword,
    setNewPassword,
    confirmPassword,
    setConfirmPassword,
}) => {
    return (
        <DialogContent>
            <PasswordInput
                label="Contraseña actual"
                setData={setOriginalPassword}
                data={originalPassword}
            />
            <PasswordInput label="Nueva contraseña" setData={setNewPassword} data={newPassword} />
            <PasswordInput
                label="Confirmar contraseña"
                setData={setConfirmPassword}
                data={confirmPassword}
            />
        </DialogContent>
    );
};
